import { z } from 'zod';

import { TypeIndustry } from '../models/contentful-generated';
import { ContentfulAssetSchema } from './contentful-asset.validator';
import { ContentfulDocumentSchema } from './contentful-document.validator';
import { ContentfulSysSchema } from './contentful-sys.validator';
import { SeoMetadataEntrySchema } from './seo-metadata.validator';
import { SynonymEntrySchema } from './synonym.validator';

export const IndustryEntrySchema = z.object({
  sys: ContentfulSysSchema,
  fields: z.looseObject({
    slug: z.string(),
    name: z.string().optional().nullable(),
    shortDescription: ContentfulDocumentSchema.optional().nullable(),
    description: ContentfulDocumentSchema.optional().nullable(),
    keyAreas: z.array(z.string()).optional().nullable(),
    image: ContentfulAssetSchema.optional().nullable(),
    maxRelatedBrands: z.number().int().optional().nullable(),
    seoMetadata: SeoMetadataEntrySchema.optional().nullable(),
    callToActionType: z.enum(['Filter on Industry', 'Off']).optional().nullable(),
    synonyms: z.array(SynonymEntrySchema).optional().nullable()
  }),
  metadata: z
    .object({
      tags: z.array(z.any()).optional().nullable()
    })
    .optional()
    .nullable()
});

export function validateIndustryEntry(data: TypeIndustry) {
  return IndustryEntrySchema.safeParse(data);
}

/**
 * Returns validation result.
 *
 * @param data
 */
export function validateIndustryEntries(data: TypeIndustry[]) {
  return z.array(IndustryEntrySchema).safeParse(data);
}

/**
 * Returns valid entries only. In most cases, this is preferred,
 * It allows us to still show some entries instead of showing nothing when only a single entry is invalid.
 *
 * @param data
 */
export function validateAndFilterIndustryEntries(data: TypeIndustry[]) {
  if (!data) return [];

  return data.reduce((acc: TypeIndustry[], entry) => {
    const validationResult = validateIndustryEntry(entry);
    if (validationResult.success) {
      acc.push(validationResult.data as unknown as TypeIndustry);
    } else {
      console.warn(
        `Validation failed for industry entry with id: '${entry?.sys?.id}'. It will be filtered out. Error: ${validationResult.error.message}`
      );
    }
    return acc;
  }, []);
}
